/**
 * L'AMORÇAGE DÉMARRE AVANT LE ROUTEUR, et ce n'est pas un détail d'ordre.
 *
 * ─── L'INCIDENT ─────────────────────────────────────────────────────────────
 *
 * Le laissez-passer arrive dans le FRAGMENT de l'adresse, et il est prélevé —
 * puis effacé — dès la première instruction de l'amorçage. Or `createWebHistory`
 * capture `window.location` à la CRÉATION du routeur : le routeur mémorisait
 * donc l'adresse AVEC le jeton, et la réécrivait à la première navigation.
 *
 * Résultat observé en production : le jeton restait visible dans la barre
 * d'adresse après la connexion — donc dans l'historique, dans un signet, dans
 * tout lien recopié. Il est à usage unique, mais un secret qui traîne reste un
 * secret qui traîne, et le module `retourLancement` documente précisément
 * l'inverse.
 *
 * ─── LA CONTRAINTE ──────────────────────────────────────────────────────────
 *
 * Les imports d'un module s'exécutent dans leur ordre de déclaration. Ce module
 * doit donc rester le PREMIER import de `main.ts`, avant celui du routeur.
 * L'y remettre plus bas rouvrirait le défaut en silence : rien ne casse, le
 * jeton réapparaît simplement dans l'adresse.
 */
import { demarrerAmorcage } from './amorcage'

demarrerAmorcage()
